import { TrendingUp, TrendingDown } from "lucide-react";
import { Card } from "@/components/ui/card";
import { BarChart, Bar, ResponsiveContainer, Cell, YAxis, Tooltip } from "recharts";

const fmtBRL = (v) =>
  Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const COLORS = ["#06B6D4", "#8B5CF6", "#10B981", "#F59E0B", "#EF4444"];

export default function ExpenseSummaryCard({ data }) {
  const delta = data?.delta_pct;
  const isUp = delta != null && delta >= 0;
  const TrendIcon = isUp ? TrendingUp : TrendingDown;
  const trendColor = isUp ? "text-amber-400" : "text-emerald-400";
  const cats = data?.by_category || [];

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="flex items-baseline justify-between mb-3">
        <div>
          <div className="text-xs text-foreground-muted">Gastos do mês</div>
          <div className="text-2xl font-bold text-foreground">
            {fmtBRL(data?.total_current)}
          </div>
        </div>
        {delta != null && (
          <div className={`flex items-center gap-1 ${trendColor} text-xs font-medium`}>
            <TrendIcon className="w-3.5 h-3.5" />
            {delta > 0 ? "+" : ""}
            {delta}% vs mês ant.
          </div>
        )}
      </div>

      {cats.length > 0 && (
        <>
          <ResponsiveContainer width="100%" height={120}>
            <BarChart data={cats} layout="vertical" margin={{ left: 8, right: 8 }}>
              <YAxis
                type="category"
                dataKey="name"
                width={80}
                tick={{ fontSize: 10, fill: "#94A3B8" }}
              />
              <Tooltip formatter={(v) => fmtBRL(v)} cursor={{ fill: "rgba(99,102,241,0.05)" }} />
              <Bar dataKey="value" radius={[0, 4, 4, 0]}>
                {cats.map((_, idx) => (
                  <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>

          <div className="mt-2 space-y-1">
            {cats.slice(0, 3).map((cat) => (
              <div key={cat.name} className="flex justify-between text-xs">
                <span className="text-foreground-muted truncate mr-2">{cat.name}</span>
                <span className="text-foreground font-medium">{fmtBRL(cat.value)}</span>
              </div>
            ))}
          </div>
        </>
      )}
      {cats.length === 0 && (
        <div className="text-xs text-foreground-muted py-4 text-center">
          Nenhuma despesa registrada esse mês.
        </div>
      )}
    </Card>
  );
}
